import { NewsCard } from '@/components/news/NewsCard';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { NewsItem } from '@/lib/newsHelpers';

const NewsSection = () => {

  const { data: news = [] } = useQuery<NewsItem[]>({
    queryKey: ['news'],
    queryFn: async () => {
      const { data } = await supabase
        .from('news')
        .select('*')
        .eq('published', true)
        .order('date', { ascending: false })
        .limit(6);
      return (data as NewsItem[]) || [];
    },
  });

  return (
    <section id="aktualnosci" className="py-16 lg:py-24 bg-muted/50">
      <div className="container">
        <p className="text-sm font-semibold text-secondary uppercase tracking-wider mb-2">
          Co słychać w Kuźni
        </p>
        <h2 className="text-3xl lg:text-4xl font-heading font-bold mb-3">Aktualności</h2>
        <p className="text-muted-foreground mb-10">Bądź na bieżąco z działaniami Kuźni.</p>

        {news.length === 0 ? (
          <p className="text-center text-muted-foreground py-12">
            Aktualności pojawią się wkrótce.
          </p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {news.map((item, i) => <NewsCard key={item.id} item={item} index={i} headingLevel="h3" />)}
          </div>
        )}

        {news.length > 0 && (
          <div className="text-center mt-10">
            <Link
              to="/aktualnosci"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary text-primary-foreground font-semibold hover:bg-primary/90 transition-colors focus:outline-none focus:ring-2 focus:ring-primary"
            >
              Zobacz wszystkie aktualności →
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default NewsSection;
